<div class="fixed-center">
  @for (toast of toasts; track toast.toastId) {
    <div>
      <ngb-alert
        class="alert-border"
        [type]="toast.type.toString()"
        [dismissible]="toast.dismissible"
        (closed)="deleteToast(toast)">

        <!-- if template supplied use it, else if error use error template, else if message use i18nTemplate else use textTemplate -->
        <ng-template
          [ngTemplateOutlet]="toast.template ? toast.template :
            toast.error ? errorTemplate :
              toast.message ? i18nTemplate : textTemplate"
          [ngTemplateOutletContext]="{toast: toast}">
        </ng-template>

      </ngb-alert>
    </div>
  }
</div>

<ng-template #errorTemplate let-toast=toast>
  <div class="mt-1">
    <div class="float-start">
      <fa-icon [icon]="['fas', 'exclamation-triangle']" [fixedWidth]="true" size="2x"/>
    </div>
  </div>
  <div class="mt-2 text-center">
    <strong>{{ 'An Error Occurred' | messageTranslate }}</strong>
  </div>
  <div class="mt-3">
    <ng-template
      [ngTemplateOutlet]="toast.message ? i18nTemplate : textTemplate"
      [ngTemplateOutletContext]="{toast: toast}">
    </ng-template>
  </div>
</ng-template>

<ng-template #textTemplate let-toast=toast>
  {{ toast.text }}
</ng-template>

<ng-template #i18nTemplate let-toast=toast>
  {{ toast.message.messageKey | messageTranslate:toast.message.parameters }}
</ng-template>
